<template lang="html">

    <section class="ruleta-container row-center">

        <h2 class="title -pc">¡Gira y gana!</h2>

        <div class="contenedor-ruleta">
            <img src="/static/img/momento-ganador/ruleta.png" alt="Ruleta" class="ruleta">
            <img src="/static/img/momento-ganador/marcador.png" alt="Marcador" class="marcador" :spinning="spinning">
            <img src="/static/img/momento-ganador/spinner.png" alt="spinner" class="spinner">
        </div>

        <div>
            <h2 class="title">¡Gira y gana!</h2>
            <a class="btn" @click="spin">Gira la ruleta</a>
        </div>


    </section>

</template>

<script lang="js">

    import { mapActions, mapGetters } from 'vuex';



    export default {
        name: 'ruleta',
        data() {
            return {
                spinning: true
            }
        },
        computed: {
            ...mapGetters({
                result: 'getResultParticipacion',
                tiradaExtra: 'getShowTiradaExtra'
            })
        },
        methods: {
            spin() {
                const DEGRESS = 36;
                // const DEGRESS = 25.71;

                const TOMIDDLE = DEGRESS / 2;

                let pos;

                const posiciones = {
                    "5": 0, //LOS40
                    "4": 1, //ENTRADAS
                    "9": 2, //AMAZON
                    "7": 8,  //SETUP
                    "1": 5, //SPOTIFY
                    // "1": 4, //SPOTIFY
                    // "2": 13, //ALTAAVOCES
                    // "3": 6, //AURICULARES
                    // "4": 12, //ENTRADAS
                    // "5": 11, //LOS40
                    // "6": 7,  //NINTENDO
                    // "7": 9,  //SETUP
                    // "8": 3, //PSSTORE
                    // "9": 14, //AMAZON
                }
                // pos = 3;
                if (!!this.result.ganador) {
                    if (this.tiradaExtra) {
                        pos = 4
                    } else {
                        pos = posiciones[this.result.datosPremio.idPremio];
                    }

                } else {
                    pos = 3
                }

                $(".spinner").attr('style', `transform:rotate(${2214 - (DEGRESS * pos) + TOMIDDLE}deg)`)


                setTimeout(e => {
                    this.$emit("finish");
                }, 5500)
            }
        },

    }
</script>


// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/ruleta.vue